
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    button: {
        backgroundColor: '#00c8ff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 700,
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        fontSize: '19px',
        lineHeight: '22px',
        letterSpacing: 'undefined',
        paddingTop: '0px',
        paddingBottom: '0px',
        color: '#ffffff',
        padding: '12px',
        textAlign: 'center',
        width: '100%'
    },
    container: {
        backgroundColor: '#ffffff',
        borderTop: '1px solid #DBDBDB',
        bottom: '0px',
        paddingTop: '16px',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingBottom: '16px',
        position: 'absolute',
        width: '100%'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarPanel/FullScreenPanel/PanelFooter/styles.js